import { Button } from "primereact/button";
import { Calendar } from "primereact/calendar";
import useIsMobile from "../../../hooks/useIsMobile";
import { InputText } from "primereact/inputtext";

const AttendanceFilter = (props) => {
  const { selectedDate, setSelectedDate, onClickRefresh, filterValue, setFilterValue } = props;
  const isMobile = useIsMobile();

  return (
    <div className={isMobile ? "col-start-start gap-3 w-full" : "row-between-end gap-4 w-full"}>
      {/* filter component section */}
      <div className={isMobile ? "col-start-start gap-3" : "row-start-center gap-4"}>
        <div className="row-start-center gap-3">
          <div className="row-start-center w-full gap-3">
            <i className="pi pi-calendar text-slate-500" />
            <label className="font-bold text-sm text-slate-500">
              Date
            </label>
            <Calendar
              id="date"
              value={selectedDate}
              onChange={(e) => setSelectedDate(e.value)}
              dateFormat="dd/mm/yy"
              showIcon
              className="w-full"
            />
          </div>
        </div>
        {/* <div className="row-start-center gap-3">
          <div className="row-start-center w-full gap-3">
            <i className="pi pi-user text-slate-500" />
            <label className="font-bold text-sm text-slate-500">
              Name
            </label>
            <InputText
              id="nama"
              value={filterValue?.nama}
              onChange={(e) =>
                setFilterValue({ ...filterValue, nama: e.target.value })
              }
              onKeyDown={(e) => {
                if (e.key === "Enter") {
                  if (onClickRefresh) onClickRefresh();
                }
              }}
              className="w-full"
            />
          </div>
        </div> */}
      </div>
      {/* refresh section */}
      <Button
        icon="pi pi-refresh"
        outlined
        rounded
        onClick={() => {
          if (onClickRefresh) onClickRefresh();
        }}
        className={isMobile ? "w-full" : ""}
      />
    </div>
  );
};

export default AttendanceFilter;
